import { render, staticRenderFns } from "./clinicDeptType.vue?vue&type=template&id=203d147e&scoped=true&"
import script from "./clinicDeptType.vue?vue&type=script&lang=js&"
export * from "./clinicDeptType.vue?vue&type=script&lang=js&"
import style0 from "./clinicDeptType.vue?vue&type=style&index=0&id=203d147e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d147e",
  null
  
)

export default component.exports